export default __webpack_public_path__ + "static/media/banner.f6c160de.png";